import React, { useEffect } from 'react';
import seekLogo from '../../assets/sai-seek-logo.png';
import lockIcon from '../../assets/new-icons/lock-icon.png';

const SAIPage: React.FC = () => {
	useEffect(() => {
		const aiDiv = document.createElement('div');
		aiDiv.style.position = 'fixed';
		aiDiv.innerHTML = `
    	<elevenlabs-convai class="sai-app" agent-id="lNhx9jFLds2BEmzns8OY"></elevenlabs-convai>
		`;
		document.body.appendChild(aiDiv);
		return () => {
			document.body.removeChild(aiDiv);
		};
	}, []);

	return (
		<div style={styles.container}>
			<div className='bg-container'>
				<div className='animated-circle' />
				<img className='logo' src={seekLogo} alt='' />
				<div className='disclaimer'>
					<img className='lock-icon' src={lockIcon} alt='' />
					<p>Conversations with Sai are 100% private and anonymous</p>
				</div>
				<style>{`
        .bg-container {
          width: 100vw;
          height: 100vh;
          background-color: #ffffff;
          display: flex;
          align-items: center;
          overflow:hidden;
          justify-content: center;
        }

        .animated-circle {
          width: 80vw;
          height: 80vw;
          border-radius: 50%;
          margin-bottom: 40px;
          background: radial-gradient(circle at center, #4462EF 20%, #1B3DD8 40%, #F0F2FE 70%);
          background-size: 400% 400%;
          animation: swirl 8s ease-in-out infinite;
          filter: blur(0.5px);
        }
        
        .logo {
          width: 80vw;
          margin-bottom: 40px;
          position: absolute;
          animation: rotate 60s infinite linear;
        }

        .disclaimer {
          position: absolute;
          bottom: 40px;
          color: #3A3A3A;
				  font-family: Gordita-Regular;
					font-size: 12px;
          display: flex;
          gap: 4px;
          padding: 4px;
          background-color: #eee;
          border-radius: 8px;
          align-items: center;
        }

        .disclaimer p {
          margin-bottom: 0;
        }

        .lock-icon {
          width: 16px;
        }
        
        @keyframes rotate {
            0% {
                transform: rotate(0);
            }
            100% {
                transform: rotate(360deg);
            }
        }

        @keyframes swirl {
          0% {
            background-position: 0% 50%;
            transform: rotate(0deg);
          }
          50% {
            background-position: 100% 50%;
            transform: rotate(180deg);
          }
          100% {
            background-position: 0% 50%;
            transform: rotate(360deg);
          }
        }
      `}</style>
			</div>
		</div>
	);
};

const styles: { [key: string]: React.CSSProperties } = {
	container: {
		margin: 0,
		fontFamily: 'Gordita-Medium',
		background: 'linear-gradient(135deg, #F0F2FE, #FFF6EC)',
		color: '#1B1625',
		height: '100vh',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		textAlign: 'center',
		padding: '0',
	},
	heading: {
		color: '#4462EF',
		fontSize: '2.8rem',
		marginBottom: '1rem',
	},
	paragraph: {
		color: '#4A4A4A',
		fontSize: '1.25rem',
		maxWidth: '600px',
		marginBottom: '0.75rem',
	},
	lightText: {
		color: '#A4A4A4',
		fontSize: '1rem',
	},
};

export default SAIPage;
